import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService, Command, CommandService, Country, User, UserActions } from '@spartacus/core';
import { UserRegisterService } from '@spartacus/user/profile/core';
import { UserSignUp } from '@spartacus/user/profile/root';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomDocumentIdentifierValidatorConnector } from '../../../../../custom/cms-components/myaccount/custom-tickets/conectors/custom-document-identifier-validator.connector';
import { DocumentIdentifierValidatorSuccess } from '../../../../../custom/cms-components/myaccount/custom-tickets/store/actions/custom-document-identifier-validator.action';
import { DocumentIdentifierType, JobType, UserTaxGroup } from '../../../../../spartacus-custom.module';
import { LoadDocumentIdentifierTypes, LoadJobTypes, LoadUserTaxGroups } from '../../custom-register/store/actions/custom-user-profile.action';
import { CustomUserProfileConnector } from '../../custom-register/store/conectors/custom-user-profile.connector';
import { CustomUserProfileService } from './custom-user-profile.service';
import { CustomUserRegisterFacade } from './custom-user-register.facade';

@Injectable({
  providedIn: 'root'
})
export class CustomUserRegisterService extends UserRegisterService implements CustomUserRegisterFacade {
  constructor(
    protected userProfile: CustomUserProfileService,
    protected userConnector: CustomUserProfileConnector,
    protected authService: AuthService,
    protected command: CommandService,
    protected customDocumentIdentifierValidatorConnector: CustomDocumentIdentifierValidatorConnector,
    protected store: Store
  ) {
    super(userProfile, userConnector, authService, command, store);
  }

  protected registerCommand: Command<{ user: UserSignUp }, User> = this.command.create(({ user }) =>
    this.userConnector.register(user).pipe(
      tap(() => {
        // this is a compatibility mechanism only, to make anonymous consents
        // management work properly in transitional period (when we move logic
        // to separate libraries)
        this.store.dispatch(new UserActions.RegisterUserSuccess());
      })
    )
  );

  protected documentIdentifierValidatorCommand: Command<{ user: UserSignUp }, User> = this.command.create(({ user }) =>
    this.customDocumentIdentifierValidatorConnector.documentIdentifierValidator(user).pipe(
      tap(() => {
        this.store.dispatch(new DocumentIdentifierValidatorSuccess());
      })
    )
  );

  getCountries(): Observable<Country[]> {
    return this.userProfile.getCountries();
  }

  getJobTypes(): Observable<JobType[]> {
    return this.userProfile.getJobTypes();
  }

  getDocumentIdentifierTypes(): Observable<DocumentIdentifierType[]> {
    return this.userProfile.getDocumentIdentifierTypes();
  }

  loadJobTypes(): void {
    this.store.dispatch(new LoadJobTypes());
  }
  getUserTaxGroups(): Observable<UserTaxGroup[]> {
    return this.userProfile.getUserTaxGroups();
  }
  loadUserTaxGroups(): void {
    this.store.dispatch(new LoadUserTaxGroups());
  }
  loadDocumentIdentifierTypes(): void {
    this.store.dispatch(new LoadDocumentIdentifierTypes());
  }

  documentIdentifierValidator(user: UserSignUp): Observable<User> {
    return this.documentIdentifierValidatorCommand.execute({ user });
  }

  // documentIdentifierValidator(user: UserSignUp): void {
  //  this.store.dispatch(new DocumentIdentifierValidator(user));
  // }
}
